module.exports = __webpack_public_path__ + "img/avatar3.d76c6655.png";